<script setup lang="ts">
/**
 * Terminal mockup card (DESIGN.md terminal-card): macOS traffic-light header +
 * a short mono session. The home page's only "product preview".
 */
defineProps<{ title?: string }>();
</script>

<template>
  <div class="terminal-card w-full text-left">
    <!-- Header: traffic lights + optional title -->
    <div class="flex items-center gap-2 pb-3 border-b border-hairline mb-3">
      <span class="terminal-dot bg-term-red" />
      <span class="terminal-dot bg-term-yellow" />
      <span class="terminal-dot bg-term-green" />
      <span v-if="title" class="ml-2 text-xs text-mute">{{ title }}</span>
    </div>
    <!-- Body -->
    <div class="overflow-x-auto">
      <slot />
    </div>
  </div>
</template>
